import { cva } from 'class-variance-authority';

export const container = cva([
  'flex flex-col items-center h-full w-full min-h-screen p-4',
]);

export const main = cva([
  'flex flex-col flex-1 w-full h-full max-w-screen-xl p-4',
]);
